import React, { useEffect } from 'react';
import { UpdateWorkspace } from '../../../../shared/types/workspaceTypes';
import { OnboardingProgress } from './OnboardingProgress';
import { OnboardingStep2InputArea } from './OnboardingStep2InputArea';
import { FlexRow } from '../../../../shared/FlexRow';
import { FilledButton, TextButton } from '../../../../shared/styled-components/styled_buttons';
import { OnboardingStep2Preview } from './OnboardingStep2Preview';
import styled from 'styled-components';
import { useTrack } from '@hackler/react-sdk';

interface Props {
  data: UpdateWorkspace;
  onChange: (data: UpdateWorkspace) => void;
  onPrev: () => void;
  onNext: () => void;
}

export const OnboardingStep2: React.FC<Props> = ({ data, onChange, onPrev, onNext }) => {
  const track = useTrack();

  useEffect(() => {
    track({ key: 'view_workspaces_step2' });
  }, []);

  const handleInputClick = () => {
    track({ key: 'click_input_application_link' });
  };

  return (
    <Container>
      <InputWrapper>
        <OnboardingProgress step={2} />
        <OnboardingStep2InputArea data={data} handleInputClick={handleInputClick} onChange={onChange} />
        <FlexRow width={'100%'} justify={'space-between'} align={'center'}>
          <TextButton
            size={'m'}
            color={'mono'}
            icon={{ src: '/images/common/chevron.svg', slot: 'start' }}
            onClick={() => {
              onPrev();
            }}
          >
            이전
          </TextButton>
          <FilledButton
            size={'m'}
            color={'primary'}
            icon={{ src: '/images/common/chevron.svg', slot: 'end', rotate: '180deg' }}
            onClick={() => {
              onNext();
            }}
          >
            시작하기
          </FilledButton>
        </FlexRow>
      </InputWrapper>
      <OnboardingStep2Preview data={data} />
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  padding: 4rem 2.4rem;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 3.2rem;
`;

const InputWrapper = styled.div`
  width: 49.8rem;

  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 3.2rem;
`;
